import React from "react";
import { Link } from "react-router-dom";

// Background image
import serviceBg from "../../images/bg/service-gradient-bg.png";

// Product images (thumbnails for cards)
import caproThumb from "../../images/service/capro-thumb.jpg";
import vaproThumb from "../../images/service/vapro-thumb.jpg";
import haproThumb from "../../images/service/hapro-thumb.jpg";
import saproThumb from "../../images/service/sapro-thumb.jpg";
import taproThumb from "../../images/service/tapro-thumb.jpg";
import inproThumb from "../../images/service/inpro-thumb.jpg";

const ServiceSection: React.FC = () => {
  // ========================
  // ICON SVG
  // ========================
  const arrowIcon = (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6.29004"
        y="21.4111"
        width="22.36"
        height="2.83936"
        transform="rotate(-40.2798 6.29004 21.4111)"
        fill="white"
      />
      <rect
        x="9.44824"
        y="7.57031"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 9.44824 7.57031)"
        fill="white"
      />
      <rect
        x="13.4492"
        y="7.90015"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 13.4492 7.90015)"
        fill="white"
      />
      <rect
        x="17.4512"
        y="8.23047"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 17.4512 8.23047)"
        fill="white"
      />
      <rect
        x="21.123"
        y="12.5627"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 21.123 12.5627)"
        fill="white"
      />
      <rect
        x="20.793"
        y="16.5649"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 20.793 16.5649)"
        fill="white"
      />
      <rect
        x="20.4619"
        y="20.5669"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 20.4619 20.5669)"
        fill="white"
      />
    </svg>
  );

  // ========================
  // ARRAY DATA
  // ========================
  const services = [
    {
      title: "Capro",
      content:
        "Stop losing revenue to voicemail. CAPRO answers every call instantly to handle bookings, take orders, and qualify leads. Most businesses see a 30% to 50% jump in leads that used to disappear.",
      images: [caproThumb, caproThumb, caproThumb, caproThumb],
      link: "/products/capro",
    },
    {
      title: "Vapro",
      content:
        "Stop struggling with social strategy. VAPRO manages your presence on 7 platforms by creating posts and images in your voice. See a 340% jump in engagement and 2.5x faster growth within 90 days.",
      images: [vaproThumb, vaproThumb, vaproThumb, vaproThumb],
      link: "/products/vapro",
    },
    {
      title: "Hapro",
      content:
        "Stop wasting weeks on recruitment. HAPRO screens candidates via smart video interviews to evaluate skills on their schedule. Cut screening time by 85% and move from posting to shortlist in two days.",
      images: [haproThumb, haproThumb, haproThumb, haproThumb],
      link: "/products/hapro",
    },
    {
      title: "Sapro",
      content:
        "Stop chasing cold leads manually. SAPRO handles outbound sales calls 24/7, qualifying prospects and booking meetings. Triple your qualification rates and book 45% more meetings while cutting costs.",
      images: [saproThumb, saproThumb, saproThumb, saproThumb],
      link: "/products/sapro",
    },
    {
      title: "Tapro",
      content:
        "Stop repeating training sessions. TAPRO runs AI roleplay simulations for sales and service so your team can practice. Onboard 40% faster and retain skills 3x longer than with traditional methods.",
      images: [taproThumb, taproThumb, taproThumb, taproThumb],
      link: "/products/tapro",
    },
    {
      title: "Inpro",
      content:
        "Stop guessing and start knowing. INPRO unifies all your data from calls, social, and sales into one clear dashboard. Gain 360° visibility and make data-driven decisions 5x faster than manual reporting.",
      images: [inproThumb, inproThumb, inproThumb, inproThumb],
      link: "/products/inpro",
    },
  ];

  // ========================
  // RETURN SECTION
  // ========================
  return (
    <section
      className="service pos-rel bg_img"
      style={{ backgroundImage: `url(${serviceBg})` }}
    >
      <div className="container">
        <div className="row mt-none-30">
          {services.map((service, index) => (
            <div className="col-lg-6 mt-30" key={index}>
              <div className="xb-ser-item xb-border img-hove-effect">
                <div className="xb-item--inner">
                  <h3 className="xb-item--title border-effect">
                    <Link to={service.link}>{service.title}</Link>
                  </h3>

                  <Link className="xb-item--icon" to={service.link}>
                    {arrowIcon}
                  </Link>

                  <p className="xb-item--content">{service.content}</p>

                  <div className="xb-item--img xb-img">
                    <Link to={service.link}>
                      <img src={service.images[0]} alt={service.title} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
